import React from "react";
import StableInput from "../../common/StableInput";

const OrganizationProfile = ({ questionnaireData, handleOrgProfileChange }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-medium text-gray-900">
        Organization Profile
      </h3>
      <p className="text-gray-600">
        Please provide basic information about your organization to help us
        customize the migration process.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Organization Name
          </label>
          <StableInput
            initialValue={questionnaireData.orgProfile.name}
            onSave={(value) => handleOrgProfileChange("name", value)}
            placeholder="Enter organization name"
          />
        </div>

        <div className="col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Contact Name
          </label>
          <StableInput
            initialValue={questionnaireData.orgProfile.contactName}
            onSave={(value) => handleOrgProfileChange("contactName", value)}
            placeholder="Full name"
          />
        </div>

        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Contact Email
          </label>
          <StableInput
            initialValue={questionnaireData.orgProfile.contactEmail}
            onSave={(value) => handleOrgProfileChange("contactEmail", value)}
            placeholder="Email address"
            type="email"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Contact Phone
          </label>
          <StableInput
            initialValue={questionnaireData.orgProfile.contactPhone}
            onSave={(value) => handleOrgProfileChange("contactPhone", value)}
            placeholder="Phone number"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Organization Size
          </label>
          <select
            className="w-full p-2 border border-gray-300 rounded"
            value={questionnaireData.orgProfile.size}
            onChange={(e) => handleOrgProfileChange("size", e.target.value)}
          >
            <option value="100-1000">100-1,000 employees</option>
            <option value="1000-10000">1,000-10,000 employees</option>
            <option value=">10000">More than 10,000 employees</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sector
          </label>
          <select
            className="w-full p-2 border border-gray-300 rounded"
            value={questionnaireData.orgProfile.sector}
            onChange={(e) => handleOrgProfileChange("sector", e.target.value)}
          >
            <option value="">Select sector</option>
            <option value="federal">Federal</option>
            <option value="public">Public</option>
            <option value="private">Private</option>
            <option value="nonprofit">Non-Profit</option>
          </select>
        </div>

        <div className="col-span-3">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="unionized"
              className="h-4 w-4 text-blue-600 rounded border-gray-300"
              checked={questionnaireData.orgProfile.unionized}
              onChange={(e) =>
                handleOrgProfileChange("unionized", e.target.checked)
              }
            />
            <label
              htmlFor="unionized"
              className="ml-2 block text-sm text-gray-700"
            >
              Unionized workforce
            </label>
          </div>
        </div>

        {(questionnaireData.orgProfile.sector === "federal" ||
          questionnaireData.orgProfile.sector === "public" ||
          questionnaireData.orgProfile.sector === "nonprofit") && (
          <div className="col-span-3">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="receivesGrants"
                className="h-4 w-4 text-blue-600 rounded border-gray-300"
                checked={questionnaireData.orgProfile.receivesGrants}
                onChange={(e) =>
                  handleOrgProfileChange("receivesGrants", e.target.checked)
                }
              />
              <label
                htmlFor="receivesGrants"
                className="ml-2 block text-sm text-gray-700"
              >
                Organization receives Grants/Aids
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrganizationProfile;
